export enum MstoreException {
  DomainMoveFailed = 'DomainMoveFailed',
  DomainMoveTimeout = 'DomainMoveTimeout'
}
